@if (isTranslationLoaded()) {
  <cfp-card [useH1]="true" [title]="'selfOnboarding.registrationClosed.title' | translate">
    <p class="mb-4">{{ 'selfOnboarding.registrationClosed.message' | translate }}</p>
    <cfp-link [url]="redirectUrl" [buttonStyle]="'primary'">{{
      'selfOnboarding.registrationClosed.button' | translate
    }}</cfp-link>
  </cfp-card>
}
